import { Action, isAnyOf } from "@reduxjs/toolkit";
import { ListenerApi } from "core/src/store/store.types";
import { navigate } from "../useCases/navigate/navigate.use-case";
import { storeLatestLocation } from "../useCases/store-latest-location/storeLatestLocation.use-case";
import { initApp } from "../../app/useCases/init-app/initApp.use-case";

export const afterNavigateListener = {
	matcher: isAnyOf(
		navigate.fulfilled,
		initApp.fulfilled
	),
	effect: (action: Action, listenerApi: ListenerApi) => {
		if (action.type === navigate.fulfilled.type) {
			// Attendre une fraction de seconde avant de stocker la location en cas de navigation
			setTimeout(() => {
				listenerApi.dispatch(storeLatestLocation());
			}, 50);
		} else {
			listenerApi.dispatch(storeLatestLocation());
		}
	}
};
